export const en = [
  { name: "aliceblue", class: "app_sel_color_aliceblue", color: "#f0f8ff" },
  {
    name: "antiquewhite",
    class: "app_sel_color_antiquewhite",
    color: "#faebd7"
  },
  { name: "aqua", class: "app_sel_color_aqua", color: "#00ffff" },
  { name: "aquamarine", class: "app_sel_color_aquamarine", color: "#7fffd4" },
  { name: "azure", class: "app_sel_color_azure", color: "#f0ffff" },
  { name: "beige", class: "app_sel_color_beige", color: "#f5f5dc" },
  { name: "bisque", class: "app_sel_color_bisque", color: "#ffe4c4" },
  { name: "black", class: "app_sel_color_black", color: "#000000" },
  {
    name: "blanchedalmond",
    class: "app_sel_color_blanchedalmond",
    color: "#ffebcd"
  },
  { name: "blue", class: "app_sel_color_blue", color: "#0000ff" },
  { name: "blueviolet", class: "app_sel_color_blueviolet", color: "#8a2be2" },
  { name: "brown", class: "app_sel_color_brown", color: "#a52a2a" },
  { name: "burlywood", class: "app_sel_color_burlywood", color: "#deb887" },
  { name: "cadetblue", class: "app_sel_color_cadetblue", color: "#5f9ea0" },
  { name: "chartreuse", class: "app_sel_color_chartreuse", color: "#7fff00" },
  { name: "chocolate", class: "app_sel_color_chocolate", color: "#d2691e" },
  { name: "coral", class: "app_sel_color_coral", color: "#ff7f50" },
  {
    name: "cornflowerblue",
    class: "app_sel_color_cornflowerblue",
    color: "#6495ed"
  },
  { name: "cornsilk", class: "app_sel_color_cornsilk", color: "#fff8dc" },
  { name: "crimson", class: "app_sel_color_crimson", color: "#dc143c" },
  { name: "cyan", class: "app_sel_color_cyan", color: "#00ffff" },
  { name: "darkblue", class: "app_sel_color_darkblue", color: "#00008b" },
  { name: "darkcyan", class: "app_sel_color_darkcyan", color: "#008b8b" },
  {
    name: "darkgoldenrod",
    class: "app_sel_color_darkgoldenrod",
    color: "#b8860b"
  },
  { name: "darkgray", class: "app_sel_color_darkgray", color: "#a9a9a9" },
  { name: "darkgreen", class: "app_sel_color_darkgreen", color: "#006400" },
  { name: "darkgrey", class: "app_sel_color_darkgrey", color: "#a9a9a9" },
  { name: "darkkhaki", class: "app_sel_color_darkkhaki", color: "#bdb76b" },
  { name: "darkmagenta", class: "app_sel_color_darkmagenta", color: "#8b008b" },
  {
    name: "darkolivegreen",
    class: "app_sel_color_darkolivegreen",
    color: "#556b2f"
  },
  { name: "darkorange", class: "app_sel_color_darkorange", color: "#ff8c00" },
  { name: "darkorchid", class: "app_sel_color_darkorchid", color: "#9932cc" },
  { name: "darkred", class: "app_sel_color_darkred", color: "#8b0000" },
  { name: "darksalmon", class: "app_sel_color_darksalmon", color: "#e9967a" },
  {
    name: "darkseagreen",
    class: "app_sel_color_darkseagreen",
    color: "#8fbc8f"
  },
  {
    name: "darkslateblue",
    class: "app_sel_color_darkslateblue",
    color: "#483d8b"
  },
  {
    name: "darkslategray",
    class: "app_sel_color_darkslategray",
    color: "#2f4f4f"
  },
  {
    name: "darkslategrey",
    class: "app_sel_color_darkslategrey",
    color: "#2f4f4f"
  },
  {
    name: "darkturquoise",
    class: "app_sel_color_darkturquoise",
    color: "#00ced1"
  },
  { name: "darkviolet", class: "app_sel_color_darkviolet", color: "#9400d3" },
  { name: "deeppink", class: "app_sel_color_deeppink", color: "#ff1493" },
  { name: "deepskyblue", class: "app_sel_color_deepskyblue", color: "#00bfff" },
  { name: "dimgray", class: "app_sel_color_dimgray", color: "#696969" },
  { name: "dimgrey", class: "app_sel_color_dimgrey", color: "#696969" },
  { name: "dodgerblue", class: "app_sel_color_dodgerblue", color: "#1e90ff" },
  { name: "firebrick", class: "app_sel_color_firebrick", color: "#b22222" },
  { name: "floralwhite", class: "app_sel_color_floralwhite", color: "#fffaf0" },
  { name: "forestgreen", class: "app_sel_color_forestgreen", color: "#228b22" },
  { name: "fuchsia", class: "app_sel_color_fuchsia", color: "#ff00ff" },
  { name: "gainsboro", class: "app_sel_color_gainsboro", color: "#dcdcdc" },
  { name: "ghostwhite", class: "app_sel_color_ghostwhite", color: "#f8f8ff" },
  { name: "goldenrod", class: "app_sel_color_goldenrod", color: "#daa520" },
  { name: "gold", class: "app_sel_color_gold", color: "#ffd700" },
  { name: "gray", class: "app_sel_color_gray", color: "#808080" },
  { name: "green", class: "app_sel_color_green", color: "#008000" },
  { name: "greenyellow", class: "app_sel_color_greenyellow", color: "#adff2f" },
  { name: "grey", class: "app_sel_color_grey", color: "#808080" },
  { name: "honeydew", class: "app_sel_color_honeydew", color: "#f0fff0" },
  { name: "hotpink", class: "app_sel_color_hotpink", color: "#ff69b4" },
  { name: "indianred", class: "app_sel_color_indianred", color: "#cd5c5c" },
  { name: "indigo", class: "app_sel_color_indigo", color: "#4b0082" },
  { name: "ivory", class: "app_sel_color_ivory", color: "#fffff0" },
  { name: "khaki", class: "app_sel_color_khaki", color: "#f0e68c" },
  {
    name: "lavenderblush",
    class: "app_sel_color_lavenderblush",
    color: "#fff0f5"
  },
  { name: "lavender", class: "app_sel_color_lavender", color: "#e6e6fa" },
  { name: "lawngreen", class: "app_sel_color_lawngreen", color: "#7cfc00" },
  {
    name: "lemonchiffon",
    class: "app_sel_color_lemonchiffon",
    color: "#fffacd"
  },
  { name: "lightblue", class: "app_sel_color_lightblue", color: "#add8e6" },
  { name: "lightcoral", class: "app_sel_color_lightcoral", color: "#f08080" },
  { name: "lightcyan", class: "app_sel_color_lightcyan", color: "#e0ffff" },
  {
    name: "lightgoldenrodyellow",
    class: "app_sel_color_lightgoldenrodyellow",
    color: "#fafad2"
  },
  { name: "lightgray", class: "app_sel_color_lightgray", color: "#d3d3d3" },
  { name: "lightgreen", class: "app_sel_color_lightgreen", color: "#90ee90" },
  { name: "lightgrey", class: "app_sel_color_lightgrey", color: "#d3d3d3" },
  { name: "lightpink", class: "app_sel_color_lightpink", color: "#ffb6c1" },
  { name: "lightsalmon", class: "app_sel_color_lightsalmon", color: "#ffa07a" },
  {
    name: "lightseagreen",
    class: "app_sel_color_lightseagreen",
    color: "#20b2aa"
  },
  {
    name: "lightskyblue",
    class: "app_sel_color_lightskyblue",
    color: "#87cefa"
  },
  {
    name: "lightslategray",
    class: "app_sel_color_lightslategray",
    color: "#778899"
  },
  {
    name: "lightslategrey",
    class: "app_sel_color_lightslategrey",
    color: "#778899"
  },
  {
    name: "lightsteelblue",
    class: "app_sel_color_lightsteelblue",
    color: "#b0c4de"
  },
  { name: "lightyellow", class: "app_sel_color_lightyellow", color: "#ffffe0" },
  { name: "lime", class: "app_sel_color_lime", color: "#00ff00" },
  { name: "limegreen", class: "app_sel_color_limegreen", color: "#32cd32" },
  { name: "linen", class: "app_sel_color_linen", color: "#faf0e6" },
  { name: "magenta", class: "app_sel_color_magenta", color: "#ff00ff" },
  { name: "maroon", class: "app_sel_color_maroon", color: "#800000" },
  {
    name: "mediumaquamarine",
    class: "app_sel_color_mediumaquamarine",
    color: "#66cdaa"
  },
  { name: "mediumblue", class: "app_sel_color_mediumblue", color: "#0000cd" },
  {
    name: "mediumorchid",
    class: "app_sel_color_mediumorchid",
    color: "#ba55d3"
  },
  {
    name: "mediumpurple",
    class: "app_sel_color_mediumpurple",
    color: "#9370db"
  },
  {
    name: "mediumseagreen",
    class: "app_sel_color_mediumseagreen",
    color: "#3cb371"
  },
  {
    name: "mediumslateblue",
    class: "app_sel_color_mediumslateblue",
    color: "#7b68ee"
  },
  {
    name: "mediumspringgreen",
    class: "app_sel_color_mediumspringgreen",
    color: "#00fa9a"
  },
  {
    name: "mediumturquoise",
    class: "app_sel_color_mediumturquoise",
    color: "#48d1cc"
  },
  {
    name: "mediumvioletred",
    class: "app_sel_color_mediumvioletred",
    color: "#c71585"
  },
  {
    name: "midnightblue",
    class: "app_sel_color_midnightblue",
    color: "#191970"
  },
  { name: "mintcream", class: "app_sel_color_mintcream", color: "#f5fffa" },
  { name: "mistyrose", class: "app_sel_color_mistyrose", color: "#ffe4e1" },
  { name: "moccasin", class: "app_sel_color_moccasin", color: "#ffe4b5" },
  { name: "navajowhite", class: "app_sel_color_navajowhite", color: "#ffdead" },
  { name: "navy", class: "app_sel_color_navy", color: "#000080" },
  { name: "oldlace", class: "app_sel_color_oldlace", color: "#fdf5e6" },
  { name: "olive", class: "app_sel_color_olive", color: "#808000" },
  { name: "olivedrab", class: "app_sel_color_olivedrab", color: "#6b8e23" },
  { name: "orange", class: "app_sel_color_orange", color: "#ffa500" },
  { name: "orangered", class: "app_sel_color_orangered", color: "#ff4500" },
  { name: "orchid", class: "app_sel_color_orchid", color: "#da70d6" },
  {
    name: "palegoldenrod",
    class: "app_sel_color_palegoldenrod",
    color: "#eee8aa"
  },
  { name: "palegreen", class: "app_sel_color_palegreen", color: "#98fb98" },
  {
    name: "paleturquoise",
    class: "app_sel_color_paleturquoise",
    color: "#afeeee"
  },
  {
    name: "palevioletred",
    class: "app_sel_color_palevioletred",
    color: "#db7093"
  },
  { name: "papayawhip", class: "app_sel_color_papayawhip", color: "#ffefd5" },
  { name: "peachpuff", class: "app_sel_color_peachpuff", color: "#ffdab9" },
  { name: "peru", class: "app_sel_color_peru", color: "#cd853f" },
  { name: "pink", class: "app_sel_color_pink", color: "#ffc0cb" },
  { name: "plum", class: "app_sel_color_plum", color: "#dda0dd" },
  { name: "powderblue", class: "app_sel_color_powderblue", color: "#b0e0e6" },
  { name: "purple", class: "app_sel_color_purple", color: "#800080" },
  {
    name: "rebeccapurple",
    class: "app_sel_color_rebeccapurple",
    color: "#663399"
  },
  { name: "red", class: "app_sel_color_red", color: "#ff0000" },
  { name: "rosybrown", class: "app_sel_color_rosybrown", color: "#bc8f8f" },
  { name: "royalblue", class: "app_sel_color_royalblue", color: "#4169e1" },
  { name: "saddlebrown", class: "app_sel_color_saddlebrown", color: "#8b4513" },
  { name: "salmon", class: "app_sel_color_salmon", color: "#fa8072" },
  { name: "sandybrown", class: "app_sel_color_sandybrown", color: "#f4a460" },
  { name: "seagreen", class: "app_sel_color_seagreen", color: "#2e8b57" },
  { name: "seashell", class: "app_sel_color_seashell", color: "#fff5ee" },
  { name: "sienna", class: "app_sel_color_sienna", color: "#a0522d" },
  { name: "silver", class: "app_sel_color_silver", color: "#c0c0c0" },
  { name: "skyblue", class: "app_sel_color_skyblue", color: "#87ceeb" },
  { name: "slateblue", class: "app_sel_color_slateblue", color: "#6a5acd" },
  { name: "slategray", class: "app_sel_color_slategray", color: "#708090" },
  { name: "slategrey", class: "app_sel_color_slategrey", color: "#708090" },
  { name: "snow", class: "app_sel_color_snow", color: "#fffafa" },
  { name: "springgreen", class: "app_sel_color_springgreen", color: "#00ff7f" },
  { name: "steelblue", class: "app_sel_color_steelblue", color: "#4682b4" },
  { name: "tan", class: "app_sel_color_tan", color: "#d2b48c" },
  { name: "teal", class: "app_sel_color_teal", color: "#008080" },
  { name: "thistle", class: "app_sel_color_thistle", color: "#d8bfd8" },
  { name: "tomato", class: "app_sel_color_tomato", color: "#ff6347" },
  { name: "turquoise", class: "app_sel_color_turquoise", color: "#40e0d0" },
  { name: "violet", class: "app_sel_color_violet", color: "#ee82ee" },
  { name: "wheat", class: "app_sel_color_wheat", color: "#f5deb3" },
  { name: "white", class: "app_sel_color_white", color: "#ffffff" },
  { name: "whitesmoke", class: "app_sel_color_whitesmoke", color: "#f5f5f5" },
  { name: "yellow", class: "app_sel_color_yellow", color: "#ffff00" },
  { name: "yellowgreen", class: "app_sel_color_yellowgreen", color: "#9acd32" }
];

export const es = [
  {
    name: "Alice azul",
    class: "app_sel_color_aliceblue",
    color: "#f0f8ff"
  },
  {
    name: "blanco antiguo",
    class: "app_sel_color_antiquewhite",
    color: "#faebd7"
  },
  {
    name: "agua",
    class: "app_sel_color_aqua",
    color: "#00ffff"
  },
  {
    name: "aguamarina",
    class: "app_sel_color_aquamarine",
    color: "#7fffd4"
  },
  {
    name: "azur",
    class: "app_sel_color_azure",
    color: "#f0ffff"
  },
  {
    name: "beige",
    class: "app_sel_color_beige",
    color: "#f5f5dc"
  },
  {
    name: "sopa de mariscos",
    class: "app_sel_color_bisque",
    color: "#ffe4c4"
  },
  {
    name: "negro",
    class: "app_sel_color_black",
    color: "#000000"
  },
  {
    name: "blanchedalmond",
    class: "app_sel_color_blanchedalmond",
    color: "#ffebcd"
  },
  {
    name: "azul",
    class: "app_sel_color_blue",
    color: "#0000ff"
  },
  {
    name: "Violeta Azul",
    class: "app_sel_color_blueviolet",
    color: "#8a2be2"
  },
  {
    name: "marrón",
    class: "app_sel_color_brown",
    color: "#a52a2a"
  },
  {
    name: "Burlywood",
    class: "app_sel_color_burlywood",
    color: "#deb887"
  },
  {
    name: "cadetblue",
    class: "app_sel_color_cadetblue",
    color: "#5f9ea0"
  },
  {
    name: "monasterio",
    class: "app_sel_color_chartreuse",
    color: "#7fff00"
  },
  {
    name: "chocolate",
    class: "app_sel_color_chocolate",
    color: "#d2691e"
  },
  {
    name: "coral",
    class: "app_sel_color_coral",
    color: "#ff7f50"
  },
  {
    name: "cornflowerblue",
    class: "app_sel_color_cornflowerblue",
    color: "#6495ed"
  },
  {
    name: "seda de maiz",
    class: "app_sel_color_cornsilk",
    color: "#fff8dc"
  },
  {
    name: "carmesí",
    class: "app_sel_color_crimson",
    color: "#dc143c"
  },
  {
    name: "cian",
    class: "app_sel_color_cyan",
    color: "#00ffff"
  },
  {
    name: "azul oscuro",
    class: "app_sel_color_darkblue",
    color: "#00008b"
  },
  {
    name: "darkcyan",
    class: "app_sel_color_darkcyan",
    color: "#008b8b"
  },
  {
    name: "Darkgoldenrod",
    class: "app_sel_color_darkgoldenrod",
    color: "#b8860b"
  },
  {
    name: "gris oscuro",
    class: "app_sel_color_darkgray",
    color: "#a9a9a9"
  },
  {
    name: "verde oscuro",
    class: "app_sel_color_darkgreen",
    color: "#006400"
  },
  {
    name: "gris oscuro",
    class: "app_sel_color_darkgrey",
    color: "#a9a9a9"
  },
  {
    name: "darkkhaki",
    class: "app_sel_color_darkkhaki",
    color: "#bdb76b"
  },
  {
    name: "darkmagenta",
    class: "app_sel_color_darkmagenta",
    color: "#8b008b"
  },
  {
    name: "darkolivegreen",
    class: "app_sel_color_darkolivegreen",
    color: "#556b2f"
  },
  {
    name: "naranja oscuro",
    class: "app_sel_color_darkorange",
    color: "#ff8c00"
  },
  {
    name: "darkorchid",
    class: "app_sel_color_darkorchid",
    color: "#9932cc"
  },
  {
    name: "rojo oscuro",
    class: "app_sel_color_darkred",
    color: "#8b0000"
  },
  {
    name: "darksalmon",
    class: "app_sel_color_darksalmon",
    color: "#e9967a"
  },
  {
    name: "darkseagreen",
    class: "app_sel_color_darkseagreen",
    color: "#8fbc8f"
  },
  {
    name: "darkslateblue",
    class: "app_sel_color_darkslateblue",
    color: "#483d8b"
  },
  {
    name: "darkslategray",
    class: "app_sel_color_darkslategray",
    color: "#2f4f4f"
  },
  {
    name: "darkslategrey",
    class: "app_sel_color_darkslategrey",
    color: "#2f4f4f"
  },
  {
    name: "darkturquoise",
    class: "app_sel_color_darkturquoise",
    color: "#00ced1"
  },
  {
    name: "Violeta oscuro",
    class: "app_sel_color_darkviolet",
    color: "#9400d3"
  },
  {
    name: "Rosa profundo",
    class: "app_sel_color_deeppink",
    color: "#ff1493"
  },
  {
    name: "deepskyblue",
    class: "app_sel_color_deepskyblue",
    color: "#00bfff"
  },
  {
    name: "dimgray",
    class: "app_sel_color_dimgray",
    color: "#696969"
  },
  {
    name: "dimgrey",
    class: "app_sel_color_dimgrey",
    color: "#696969"
  },
  {
    name: "dodgerblue",
    class: "app_sel_color_dodgerblue",
    color: "#1e90ff"
  },
  {
    name: "ladrillo refractario",
    class: "app_sel_color_firebrick",
    color: "#b22222"
  },
  {
    name: "floralwhite",
    class: "app_sel_color_floralwhite",
    color: "#fffaf0"
  },
  {
    name: "bosque verde",
    class: "app_sel_color_forestgreen",
    color: "#228b22"
  },
  {
    name: "fucsia",
    class: "app_sel_color_fuchsia",
    color: "#ff00ff"
  },
  {
    name: "gainboro",
    class: "app_sel_color_gainsboro",
    color: "#dcdcdc"
  },
  {
    name: "fantasma blanco",
    class: "app_sel_color_ghostwhite",
    color: "#f8f8ff"
  },
  {
    name: "vara de oro",
    class: "app_sel_color_goldenrod",
    color: "#daa520"
  },
  {
    name: "oro",
    class: "app_sel_color_gold",
    color: "#ffd700"
  },
  {
    name: "gris",
    class: "app_sel_color_gray",
    color: "#808080"
  },
  {
    name: "verde",
    class: "app_sel_color_green",
    color: "#008000"
  },
  {
    name: "verde amarillo",
    class: "app_sel_color_greenyellow",
    color: "#adff2f"
  },
  {
    name: "gris",
    class: "app_sel_color_grey",
    color: "#808080"
  },
  {
    name: "gotas de miel",
    class: "app_sel_color_honeydew",
    color: "#f0fff0"
  },
  {
    name: "Rosa caliente",
    class: "app_sel_color_hotpink",
    color: "#ff69b4"
  },
  {
    name: "indianred",
    class: "app_sel_color_indianred",
    color: "#cd5c5c"
  },
  {
    name: "índigo",
    class: "app_sel_color_indigo",
    color: "#4b0082"
  },
  {
    name: "Marfil",
    class: "app_sel_color_ivory",
    color: "#fffff0"
  },
  {
    name: "caqui",
    class: "app_sel_color_khaki",
    color: "#f0e68c"
  },
  {
    name: "lavenderblush",
    class: "app_sel_color_lavenderblush",
    color: "#fff0f5"
  },
  {
    name: "lavanda",
    class: "app_sel_color_lavender",
    color: "#e6e6fa"
  },
  {
    name: "césped verde",
    class: "app_sel_color_lawngreen",
    color: "#7cfc00"
  },
  {
    name: "lemonchiffon",
    class: "app_sel_color_lemonchiffon",
    color: "#fffacd"
  },
  {
    name: "azul claro",
    class: "app_sel_color_lightblue",
    color: "#add8e6"
  },
  {
    name: "lightcoral",
    class: "app_sel_color_lightcoral",
    color: "#f08080"
  },
  {
    name: "cian claro",
    class: "app_sel_color_lightcyan",
    color: "#e0ffff"
  },
  {
    name: "lightgoldenrodyellow",
    class: "app_sel_color_lightgoldenrodyellow",
    color: "#fafad2"
  },
  {
    name: "gris claro",
    class: "app_sel_color_lightgray",
    color: "#d3d3d3"
  },
  {
    name: "verde claro",
    class: "app_sel_color_lightgreen",
    color: "#90ee90"
  },
  {
    name: "gris claro",
    class: "app_sel_color_lightgrey",
    color: "#d3d3d3"
  },
  {
    name: "Rosa claro",
    class: "app_sel_color_lightpink",
    color: "#ffb6c1"
  },
  {
    name: "Lucesalmon",
    class: "app_sel_color_lightsalmon",
    color: "#ffa07a"
  },
  {
    name: "verde claro",
    class: "app_sel_color_lightseagreen",
    color: "#20b2aa"
  },
  {
    name: "lightskyblue",
    class: "app_sel_color_lightskyblue",
    color: "#87cefa"
  },
  {
    name: "lightslategray",
    class: "app_sel_color_lightslategray",
    color: "#778899"
  },
  {
    name: "lightslategrey",
    class: "app_sel_color_lightslategrey",
    color: "#778899"
  },
  {
    name: "lightsteelblue",
    class: "app_sel_color_lightsteelblue",
    color: "#b0c4de"
  },
  {
    name: "amarillo claro",
    class: "app_sel_color_lightyellow",
    color: "#ffffe0"
  },
  {
    name: "Lima",
    class: "app_sel_color_lime",
    color: "#00ff00"
  },
  {
    name: "verde lima",
    class: "app_sel_color_limegreen",
    color: "#32cd32"
  },
  {
    name: "lino",
    class: "app_sel_color_linen",
    color: "#faf0e6"
  },
  {
    name: "magenta",
    class: "app_sel_color_magenta",
    color: "#ff00ff"
  },
  {
    name: "granate",
    class: "app_sel_color_maroon",
    color: "#800000"
  },
  {
    name: "mediumaquamarine",
    class: "app_sel_color_mediumaquamarine",
    color: "#66cdaa"
  },
  {
    name: "azul medio",
    class: "app_sel_color_mediumblue",
    color: "#0000cd"
  },
  {
    name: "mediumorchid",
    class: "app_sel_color_mediumorchid",
    color: "#ba55d3"
  },
  {
    name: "median",
    class: "app_sel_color_mediumpurple",
    color: "#9370db"
  },
  {
    name: "mediumseagreen",
    class: "app_sel_color_mediumseagreen",
    color: "#3cb371"
  },
  {
    name: "mediumslateblue",
    class: "app_sel_color_mediumslateblue",
    color: "#7b68ee"
  },
  {
    name: "mediumspringgreen",
    class: "app_sel_color_mediumspringgreen",
    color: "#00fa9a"
  },
  {
    name: "mediumturquoise",
    class: "app_sel_color_mediumturquoise",
    color: "#48d1cc"
  },
  {
    name: "ediano viole",
    class: "app_sel_color_mediumvioletred",
    color: "#c71585"
  },
  {
    name: "medianoche azul",
    class: "app_sel_color_midnightblue",
    color: "#191970"
  },
  {
    name: "mintcream",
    class: "app_sel_color_mintcream",
    color: "#f5fffa"
  },
  {
    name: "mistyrose",
    class: "app_sel_color_mistyrose",
    color: "#ffe4e1"
  },
  {
    name: "mocasín",
    class: "app_sel_color_moccasin",
    color: "#ffe4b5"
  },
  {
    name: "navajowhite",
    class: "app_sel_color_navajowhite",
    color: "#ffdead"
  },
  {
    name: "Armada",
    class: "app_sel_color_navy",
    color: "#000080"
  },
  {
    name: "oldlace",
    class: "app_sel_color_oldlace",
    color: "#fdf5e6"
  },
  {
    name: "aceituna",
    class: "app_sel_color_olive",
    color: "#808000"
  },
  {
    name: "verde oliva",
    class: "app_sel_color_olivedrab",
    color: "#6b8e23"
  },
  {
    name: "naranja",
    class: "app_sel_color_orange",
    color: "#ffa500"
  },
  {
    name: "rojo naranja",
    class: "app_sel_color_orangered",
    color: "#ff4500"
  },
  {
    name: "orquídea",
    class: "app_sel_color_orchid",
    color: "#da70d6"
  },
  {
    name: "alegoldenr",
    class: "app_sel_color_palegoldenrod",
    color: "#eee8aa"
  },
  {
    name: "Verde pálido",
    class: "app_sel_color_palegreen",
    color: "#98fb98"
  },
  {
    name: "paleturquoise",
    class: "app_sel_color_paleturquoise",
    color: "#afeeee"
  },
  {
    name: "palevioletre",
    class: "app_sel_color_palevioletred",
    color: "#db7093"
  },
  {
    name: "papayawhip",
    class: "app_sel_color_papayawhip",
    color: "#ffefd5"
  },
  {
    name: "peachpuff",
    class: "app_sel_color_peachpuff",
    color: "#ffdab9"
  },
  {
    name: "Perú",
    class: "app_sel_color_peru",
    color: "#cd853f"
  },
  {
    name: "rosado",
    class: "app_sel_color_pink",
    color: "#ffc0cb"
  },
  {
    name: "ciruela",
    class: "app_sel_color_plum",
    color: "#dda0dd"
  },
  {
    name: "azul pálido",
    class: "app_sel_color_powderblue",
    color: "#b0e0e6"
  },
  {
    name: "púrpura",
    class: "app_sel_color_purple",
    color: "#800080"
  },
  {
    name: "rebeccapurple",
    class: "app_sel_color_rebeccapurple",
    color: "#663399"
  },
  {
    name: "rojo",
    class: "app_sel_color_red",
    color: "#ff0000"
  },
  {
    name: "Rosybrown",
    class: "app_sel_color_rosybrown",
    color: "#bc8f8f"
  },
  {
    name: "azul real",
    class: "app_sel_color_royalblue",
    color: "#4169e1"
  },
  {
    name: "saddlebrown",
    class: "app_sel_color_saddlebrown",
    color: "#8b4513"
  },
  {
    name: "salmón",
    class: "app_sel_color_salmon",
    color: "#fa8072"
  },
  {
    name: "Sandybrown",
    class: "app_sel_color_sandybrown",
    color: "#f4a460"
  },
  {
    name: "Mar verde",
    class: "app_sel_color_seagreen",
    color: "#2e8b57"
  },
  {
    name: "concha",
    class: "app_sel_color_seashell",
    color: "#fff5ee"
  },
  {
    name: "tierra de siena",
    class: "app_sel_color_sienna",
    color: "#a0522d"
  },
  {
    name: "plata",
    class: "app_sel_color_silver",
    color: "#c0c0c0"
  },
  {
    name: "cielo azul",
    class: "app_sel_color_skyblue",
    color: "#87ceeb"
  },
  {
    name: "slateblue",
    class: "app_sel_color_slateblue",
    color: "#6a5acd"
  },
  {
    name: "lategr",
    class: "app_sel_color_slategray",
    color: "#708090"
  },
  {
    name: "pizarra gris",
    class: "app_sel_color_slategrey",
    color: "#708090"
  },
  {
    name: "nieve",
    class: "app_sel_color_snow",
    color: "#fffafa"
  },
  {
    name: "primavera verde",
    class: "app_sel_color_springgreen",
    color: "#00ff7f"
  },
  {
    name: "azul acero",
    class: "app_sel_color_steelblue",
    color: "#4682b4"
  },
  {
    name: "bronceado",
    class: "app_sel_color_tan",
    color: "#d2b48c"
  },
  {
    name: "teal",
    class: "app_sel_color_teal",
    color: "#008080"
  },
  {
    name: "cardo",
    class: "app_sel_color_thistle",
    color: "#d8bfd8"
  },
  {
    name: "tomate",
    class: "app_sel_color_tomato",
    color: "#ff6347"
  },
  {
    name: "turquesa",
    class: "app_sel_color_turquoise",
    color: "#40e0d0"
  },
  {
    name: "Violeta",
    class: "app_sel_color_violet",
    color: "#ee82ee"
  },
  {
    name: "trigo",
    class: "app_sel_color_wheat",
    color: "#f5deb3"
  },
  {
    name: "blanco",
    class: "app_sel_color_white",
    color: "#ffffff"
  },
  {
    name: "humo blanco",
    class: "app_sel_color_whitesmoke",
    color: "#f5f5f5"
  },
  {
    name: "amarillo",
    class: "app_sel_color_yellow",
    color: "#ffff00"
  },
  {
    name: "amarillo verde",
    class: "app_sel_color_yellowgreen",
    color: "#9acd32"
  }
];
